<h3>Produkttypen*</h3>
<div class="mini-grid-ptg margin fixed-size-container-300">
    <!-- <div class="mikro-grid-ptg" *ngIf="!isCertification">
        <p *ngIf="isCertification">
            Sollen der Zertifizierungsversion (weitere) Produkttypen zugeordnet
            werden?
        </p>
        <toggle-switch
            [trueLabel]="'Ja'"
            [falseLabel]="'Nein'"
            [allowUndefined]="false"
            (valueChange)="onToggle($event)"
        >
        </toggle-switch>
    </div> -->

    <div class="fixed-size-container-240">
        <div *ngIf="this.ptgWithActiveVersions != undefined" class="checkbox-container">
            <div *ngFor="let ptg of this.ptgWithActiveVersions.ptgList" class="checkbox-item">
                <mat-checkbox [checked]="isPtgSelected(ptg)"
                    [disabled]="!isPtgSelected(ptg) && version.ptgVersions.length >= 3"
                    (change)="togglePtgVersion(ptg, $event.checked)">
                    {{ ptg.name }}
                </mat-checkbox>
            </div>
        </div>
        <mat-paginator class="paginator-custom" [length]="this.ptgWithActiveVersions?.totalNumberOfElements"
            [pageSize]="this.pageSize" [pageIndex]="this.pageIndex / this.pageSize" aria-label="Select page"
            (page)="pageChanged($event)">
        </mat-paginator>
    </div>
</div>

<!-- [labelPosition]="'before'" -->